





import { defineComponent } from '@vue/composition-api';

import SaleDashboard from '@/components/Dashboard/SaleDashboard.vue';

const SaleDashboardPage = defineComponent({
  components: { SaleDashboard },
  // setup() {},
});

export default SaleDashboardPage;
